var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 1.8335C5.93692 1.8335 1.83301 5.93741 1.83301 11.0002C1.83301 16.0629 5.93692 20.1668 10.9997 20.1668C16.0624 20.1668 20.1663 16.0629 20.1663 11.0002C20.1663 5.93741 16.0624 1.8335 10.9997 1.8335ZM7.79134 8.7085C7.79134 8.28717 7.87433 7.86997 8.03556 7.48072C8.19679 7.09147 8.43312 6.73778 8.73104 6.43986C9.02896 6.14194 9.38265 5.90562 9.7719 5.74438C10.1612 5.58315 10.5784 5.50016 10.9997 5.50016C11.421 5.50016 11.8382 5.58315 12.2275 5.74438C12.6167 5.90562 12.9704 6.14194 13.2683 6.43986C13.5662 6.73778 13.8026 7.09147 13.9638 7.48072C14.125 7.86997 14.208 8.28717 14.208 8.7085C14.208 9.5594 13.87 10.3755 13.2683 10.9771C12.6666 11.5788 11.8506 11.9168 10.9997 11.9168C10.1488 11.9168 9.33272 11.5788 8.73104 10.9771C8.12936 10.3755 7.79134 9.5594 7.79134 8.7085ZM16.7362 15.5688C16.0498 16.4317 15.1774 17.1285 14.1841 17.6072C13.1908 18.0859 12.1023 18.3342 10.9997 18.3335C9.89706 18.3342 8.80852 18.0859 7.81524 17.6072C6.82196 17.1285 5.94958 16.4317 5.26317 15.5688C6.74909 14.5027 8.77676 13.7502 10.9997 13.7502C13.2226 13.7502 15.2503 14.5027 16.7362 15.5688Z",
    fill: "#707A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.036582d2c21c3182981df7459e7ea185.svg";
export { ForwardRef as ReactComponent };